const size = {
  mobile: "390px",
  pc: "1024px",
}

const device = {
  mobile: `screen and (max-width: ${size.mobile})`,
  pc: `screen and (min-width: ${size.pc})`,
}

const theme = {
  device,
}

export default theme
